import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IPlanoSaude } from '../models/plano_saude.model';

@Injectable()
export class PlanoSaudeService extends EntityService<IPlanoSaude> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'plano_saude',
      pluralBaseEntityEndPoint: 'planos_saude'
    });
  }
}
